module.exports = __webpack_public_path__ + "static/media/sama1.bf7f3d18.wav";